var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.555 3.16791C7.4044 3.06743 7.22935 3.00972 7.04852 3.00093C6.86769 2.99215 6.68786 3.03262 6.52823 3.11803C6.36861 3.20344 6.23516 3.33058 6.14213 3.4859C6.0491 3.64121 5.99997 3.81886 6 3.99991V19.9999C5.99997 20.181 6.0491 20.3586 6.14213 20.5139C6.23516 20.6692 6.36861 20.7964 6.52823 20.8818C6.68786 20.9672 6.86769 21.0077 7.04852 20.9989C7.22935 20.9901 7.4044 20.9324 7.555 20.8319L19.555 12.8319C19.692 12.7406 19.8043 12.6169 19.8819 12.4717C19.9596 12.3266 20.0002 12.1645 20.0002 11.9999C20.0002 11.8353 19.9596 11.6732 19.8819 11.5281C19.8043 11.3829 19.692 11.2592 19.555 11.1679L7.555 3.16791ZM8 18.1309V5.86891L17.2 11.9999L8 18.1309Z",
    fill: "#4A4A68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.6abfaa512f16d72a641485ec60c8993d.svg";
export { ForwardRef as ReactComponent };